module.exports = __webpack_public_path__ + "img/slack.2883696a.svg";